import resolveReference from '../resolveReference';
import resolveRTC from '../resolveRTC';
import resolveBlacklistUrls from '../resolveBlacklistUrls';
import resolveCRMSyncs from '../resolveCRMSyncs';
import resolveDocument from '../resolveDocument';
import { ComponentsVariants, isVariantOf } from '@/components.variants';

export const isDocumentPicker = isVariantOf(ComponentsVariants.DOCUMENT_PICKER, true);

export const resolveDocumentPicker = (rawVal: any, page: any, pageModels: any) => {
  const formDocument = resolveReference<any>({ rawVal: rawVal.document, page, pageModels });
  if (formDocument?.marketoFormId && formDocument?.marketoFormId.length > 0) {
    const { backgroundColor, buttonAlignment, contained, dropShadow } = rawVal;
    const {
      marketoFormId,
      rules,
      confirmationMessage,
      heading,
      description,
      emailBlacklistUrls,
      crmSyncs,
    } = formDocument;
    const { config } = pageModels || {};
    const { marketo: marketoConfig } = config || {};
    const {
      base_url: baseUrl,
      munchkin_id: munchkinId,
      recaptcha_sitekey: recaptchaSitekey,
      recaptcha_legal: recaptchaLegal,
      email_fieldname: emailFieldname,
      email_blacklist_error_message: emailBlacklistErrorMessage,
      email_crm_fieldname: emailCRMFieldname,
    } = marketoConfig || {};
    return {
      variant: 'formPicker',
      formId: marketoFormId,
      rules,
      confirmationMessage: resolveRTC({ rawVal: confirmationMessage }),
      munchkinId,
      recaptchaLegal,
      baseUrl,
      recaptchaSitekey,
      heading,
      formDescription: resolveRTC({ rawVal: description }),
      emailFieldname,
      emailBlacklistErrorMessage,
      emailsBlacklisted: resolveBlacklistUrls({ rawVal: emailBlacklistUrls }),
      emailCRMFieldname,
      CRMSyncFieldnames: resolveCRMSyncs<ICRMSyncFieldnames>({ rawVal: crmSyncs }),
      appearance: { backgroundColor, buttonAlignment, contained, dropShadow },
    };
  }
  return {
    variant: 'document',
    ...resolveDocument({ rawVal: rawVal.document, page, pageModels }),
  };
};
